import "@hotwired/turbo-rails"
Turbo.session.drive = false

import '@github/relative-time-element';

import '../stylesheets/application.css'

import '../lightbox'

import "../install"
import "../versioncheck"
import "../recaptcha"
import "../additional-info"
import "../markup-preview"
import "../submit-anchor"
import "../expandable-text"
import "../sidebar"
import "../announcements"
import "../forum"
import "../ethical-ads"
import "../locale-switcher"
import "../attachments"
import "../reports"
import "../home"
import '../source-editor'
import '../stats'
import '../login'
import '../header'
import '../code'
import '../timezone'
